import type { ReactNode } from "react";
import { ErrorPanel } from "@/components/ui/ErrorPanel";
import type { ProblemAsk } from "@/lib/problem/describe-problem";
import { useProblem } from "@/lib/problem/use-problem";

/**
 * An `ErrorPanel` for a failure: what failed and why, said through `describeProblem`, with a
 * report carrying the failure's trace and the ids of the scopes around it, never the server's
 * words or the draft's.
 */
export function ErrorState({
  error,
  onRetry,
  className,
  children,
  ...ask
}: ProblemAsk & {
  error: unknown;
  onRetry?: () => void;
  className?: string;
  children?: ReactNode;
}) {
  const { problem, report } = useProblem(error, ask);
  return (
    <ErrorPanel
      title={problem.title}
      reason={problem.reason}
      onRetry={onRetry}
      onReport={report}
      className={className}
    >
      {children}
    </ErrorPanel>
  );
}
